import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class KeepDeserted4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KEEP_DESERTED4;
}

export default KeepDeserted4PoiTileEntity;
